import styled from 'styled-components';
import { Layout } from 'antd';

const { Header } = Layout;

export const StyledPublicHeader = styled(Header)`
  background-color: #fff;
  height: auto;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid ${({ theme }): string => theme.kcc.colors.BORDER};
`;
